import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

/**
 * @deprecated This component should be replaced with Card when the design is aligned.
 */ const CardWrapper = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("div", {
        "data-t": rest['data-t'],
        className: classnames('card', className)
    }, children);
};
var CardWrapper$1 = CardWrapper;

export { CardWrapper$1 as default };
//# sourceMappingURL=CardWrapper.js.map
